export default __webpack_public_path__ + "static/media/PathMatchLogo.22ec1518.png";